import { forwardRef } from "react";
import { Navbar, Nav } from "rsuite";
import AdminIcon from "@rsuite/icons/Admin";
import { Menu } from "@rsuite/icons";
import styles from "./topNav.module.scss";
import { Link } from "react-router-dom";
import {
  AuthActions,
  useAppDispatch,
  useAppSelector,
  WtaPublisherAppState,
} from "../../../core/redux";

type topNavProps = {
  handleSideNav: () => void;
};

const TopNav = ({ handleSideNav }: topNavProps) => {
  const NavLink = forwardRef<HTMLElement>(
    ({ href, children, ...rest }: any, ref) => (
      <Link ref={ref} to={href} {...rest}>
        {children}
      </Link>
    )
  );

  const MenuIcon = ({ size }: { size: string }) => (
    <Menu style={{ fontSize: size }} />
  );

  const dispatch = useAppDispatch();
  const selector = useAppSelector((state: WtaPublisherAppState) => state);

  return (
    <Navbar className={`${styles.topNav}`}>
      <Nav>
        <Nav.Item
          className="d-block d-xl-none"
          onClick={() => handleSideNav()}
          icon={<MenuIcon size="1.5em" />}
        ></Nav.Item>

        <Nav.Item as={NavLink} href="/home" className={styles.topNavTitle}>
          <span className="fs-4">WTA Publisher</span>
        </Nav.Item>
      </Nav>

      <Nav pullRight>
        <Nav.Menu
          title={<p className="user-name">{selector.auth.userData.Username}</p>}
          icon={<AdminIcon />}
        >
          <Nav.Item
            onClick={() => dispatch(AuthActions.logout())}
            href="auth/login/"
          >
            Log Out
          </Nav.Item>
        </Nav.Menu>
      </Nav>
    </Navbar>
  );
};

export default TopNav;
